import React, { useState, useEffect } from 'react'
import { Lexicon } from '@nitidbit/lexicon'
import AbortionServices from './AbortionServices'
import NonAbortionServices from './NonAbortionServices'
import './ServicesOfferedTabs.scss'
import { NavigateClinicOffering } from '../../shared/constants.js'
import lexiconRaw from './ClinicDetailsStrings.json'

const locale = document.documentElement.lang || 'en'
const lexicon = new Lexicon(
  lexiconRaw,
  locale,
  'bedsider/app/javascript/components/ClinicDetails/ClinicDetailsStrings.json'
)

function isJSONValid(str) {
  try {
    return JSON.parse(str) && !!str
  } catch (e) {
    return false
  }
}

const ServicesOfferedTabs = ({
  title,
  allOfferings,
  clinicJson,
  stateAbortionLawJson,
  gestationalWeeksAndDays,
  stateAbortionLimit,
  initialActiveIndex = 0,
  acceptsInsurance,
  privateInsurance,
  publicInsurance,
  isFree,
  isFreeStr,
  slidingScale,
  slidingScaleStr,
  financialAssistanceAvailable,
  financialAssistanceAvailableStr,
  acceptsUninsured,
  uninsuredStr,
  paymentOptionsTitle,
  vagueIns,
  vagueInsNonAb,
  medicaidAcc,
  medicaidAccNonAb,
  privateAcc,
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(initialActiveIndex)

  const label1Class = activeTabIndex === 0 ? 'active' : ''
  const label2Class = activeTabIndex === 1 ? 'active' : ''

  useEffect(() => {
    setActiveTabIndex(initialActiveIndex)
  }, [initialActiveIndex])

  const stateAbortionLaw =
    isJSONValid(stateAbortionLawJson) && JSON.parse(stateAbortionLawJson)

  const clinic = isJSONValid(clinicJson) && JSON.parse(clinicJson)

  // we should probs revamp this, why are we creating @services in the clinics_controller but never using?
  const clinicOfferings = Object.keys(clinic.known_offerings).filter(
    (key) =>
      clinic.known_offerings[key] &&
      allOfferings[key] &&
      (key === 'ella_available' ||
        key === 'paragard_iud_as_emergency_contraception' ||
        key === 'plan_b_or_generic_available' ||
        allOfferings[key].show_on_detail)
  )

  const offersAbortionServices =
    clinicOfferings.includes(NavigateClinicOffering.ABORTION_SERVICES) &&
    !!clinic &&
    !!stateAbortionLaw

  return (
    <div className="ServicesOfferedTabs">
      <div className="header-and-tabs">
        <div className="heading-container">
          <h2>{title}</h2>
        </div>

        {offersAbortionServices && (
          <nav className="tabs-container">
            <button
              type="button"
              onClick={() => setActiveTabIndex(0)}
              className={label1Class}
            >
              {lexicon.get('non_abortion_services_title')}
            </button>

            <button
              type="button"
              onClick={() => setActiveTabIndex(1)}
              className={label2Class}
            >
              {lexicon.get('abortion_services_title')}
            </button>
          </nav>
        )}
      </div>

      <div className="content-container">
        {!offersAbortionServices && <div className="spacer" />}
        {activeTabIndex === 0 ? (
          <NonAbortionServices
            allOfferings={allOfferings}
            clinicOfferings={clinicOfferings}
            lexicon={lexicon.subset('non_abortion_services')}
            locale={locale}
            acceptsInsurance={acceptsInsurance}
            privateInsurance={privateInsurance}
            publicInsurance={publicInsurance}
            isFree={isFree}
            slidingScale={slidingScale}
            acceptsUninsured={acceptsUninsured}
            financialAssistanceAvailable={financialAssistanceAvailable}
            paymentOptionsTitle={paymentOptionsTitle}
            someIns={offersAbortionServices ? vagueIns : vagueInsNonAb}
            medicaidStr={
              offersAbortionServices ? medicaidAcc : medicaidAccNonAb
            }
            privateAcc={privateAcc}
            isFreeStr={isFreeStr}
            slidingScaleStr={slidingScaleStr}
            uninsuredStr={uninsuredStr}
            financialAssistanceAvailableStr={financialAssistanceAvailableStr}
          />
        ) : (
          offersAbortionServices && (
            <AbortionServices
              gestationalWeeksAndDays={gestationalWeeksAndDays}
              stateAbortionLimit={stateAbortionLimit}
              lexicon={lexicon.subset('abortion_services')}
              clinic={clinic}
              stateAbortionLaw={stateAbortionLaw}
              locale={locale}
            />
          )
        )}
      </div>
    </div>
  )
}

export default ServicesOfferedTabs
